__turbopack_context__.v({
  "body": "SelectMenu-module-scss-module__lwA0kG__body",
  "close": "SelectMenu-module-scss-module__lwA0kG__close",
  "header": "SelectMenu-module-scss-module__lwA0kG__header",
  "root": "SelectMenu-module-scss-module__lwA0kG__root",
});
